import { render, staticRenderFns } from "./defaultTemplate.vue?vue&type=template&id=5331c576"
import script from "./defaultTemplate.vue?vue&type=script&lang=js"
export * from "./defaultTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports